export const DEFAULT_GAP = 20;
export const DEFAULT_OFFSET = 0;
export const MIN_SLIDE_INDEX = 0;

export const VIEW_MODES = {
  SINGLE: "single",
  MULTIPLE: "multiple",
} as const;

export const ACTIVE_SLIDE_ALIGNMENTS = {
  LEFT: "left",
  CENTER: "center",
} as const;

export const CONTROL_WIDTHS = {
  small: 32,
  large: 48,
} as const;

export const TRANSITION_DURATION = 400;

export const ACTIVE_SLIDE_SCALE = 1.3;
